import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { ParkingCount } from 'domain/listing/value-objects';
import { Namespaces } from 'types/locales';
import { formatParkingCount } from './format-parking-count';

export interface UseParkingCountOptions {
  parking: number | null;
}

export interface UseParkingCountResult {
  formatted: string;
  hasValue: boolean;
}

export function useParkingCount(options: UseParkingCountOptions): UseParkingCountResult {
  const { parking } = options;
  const { t } = useTranslation(Namespaces.COMMON);

  return useMemo(() => {
    const vo = ParkingCount.from(parking);
    return {
      formatted: formatParkingCount(vo, t),
      hasValue: vo.hasValue,
    };
  }, [parking, t]);
}
